import gsap from 'gsap'
import SplitText from 'gsap/dist/SplitText'

import { PAGE_TRANSITION_ENTER_DELAY } from '@/contexts/transition'
import { MediaQuery } from '@/constants'

import {
  getScrollTriggerHorizontalOptions,
  getScrollTriggerVerticalOptions,
  isElementInViewport
} from './utils'
import { Animation } from '@/types'

export const singleParagraphRevealAnimation = ({
  node,
  reverse,
  context
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const paragraph = selector('[data-motion-paragraph]')[0]

  const splitText = new SplitText(paragraph, {
    type: 'lines',
    linesClass: 'line'
  })
  new SplitText(paragraph, { type: 'lines', linesClass: 'line-wrap' })

  const matchMedia = gsap.matchMedia(node)

  matchMedia.add(MediaQuery.SMALL, () => {
    const inView = isElementInViewport(node, false)

    gsap
      .timeline({
        ...getScrollTriggerVerticalOptions(node, reverse),
        delay: inView ? PAGE_TRANSITION_ENTER_DELAY : 0,
        onComplete: () => {
          if (reverse) return
          splitText.revert()
        }
      })
      .fromTo(
        splitText.lines,
        { yPercent: 140, skewY: 3 },
        {
          skewY: 0,
          yPercent: 0,
          duration: 0.6,
          ease: 'power2.out',
          stagger: { amount: 0.2 }
        }
      )
  })

  matchMedia.add(MediaQuery.LARGE, () => {
    const inView = isElementInViewport(node, true)

    gsap
      .timeline({
        ...getScrollTriggerHorizontalOptions(node, reverse),
        delay: inView ? PAGE_TRANSITION_ENTER_DELAY : 0,
        onComplete: () => {
          if (reverse) return
          splitText.revert()
        }
      })
      .fromTo(
        splitText.lines,
        { yPercent: 140, skewY: 3 },
        {
          skewY: 0,
          yPercent: 0,
          duration: 0.6,
          ease: 'power2.out',
          stagger: { amount: 0.2 }
        }
      )
  })

  return () => {
    if (splitText) {
      splitText.revert()
    }

    matchMedia.revert()
  }
}
